type TransKey = {
    textId: string;
    vars?: Record<string, unknown>;
};

type LoyaltyBenefit = {
    type: string;
    silver: TransKey;
    gold: TransKey;
    platinum: TransKey;
};

export const loyaltyBenefits: LoyaltyBenefit[] = [
    {
        type: 'Transaction Fees',
        silver: { textId: 'Percent Off', vars: { percent: 15 } },
        gold: { textId: 'Percent Off', vars: { percent: 25 } },
        platinum: { textId: 'First 50 Free then 50% Off' }
    },
    {
        type: 'Reserved % of  New Asset',
        silver: { textId: 'Percent Available', vars: { percent: 5 } },
        gold: { textId: 'Percent Available', vars: { percent: 10 } },
        platinum: { textId: 'Percent Available', vars: { percent: 12 } }
    },
    {
        type: 'Extra Yield in Staking Pool',
        silver: { textId: 'Percent More', vars: { percent: 0.25 } },
        gold: { textId: 'Percent More', vars: { percent: 0.5 } },
        platinum: { textId: 'Percent More', vars: { percent: 1 } }
    },
    {
        type: 'Marketplace Discount per Year',
        silver: { textId: 'Percent Up Of', vars: { percent: 10, limit: 250 } },
        gold: { textId: 'Percent Out Of', vars: { percent: 15, limit: 500 } },
        platinum: {
            textId: 'Percent Out Of',
            vars: { percent: 10, limit: 1000 }
        }
    },
    {
        type: 'NFT Minting',
        silver: { textId: 'Minting Period', vars: { week: 1, year: 1 } },
        gold: { textId: 'Yearly', vars: { year: 3 } },
        platinum: { textId: 'Minting Period', vars: { week: 1, year: 5 } }
    },
    {
        type: 'Asset Raffle',
        silver: { textId: 'Ticket Per Drawing', vars: { ticket: 1 } },
        gold: { textId: 'Number of Ticket', vars: { ticket: 2 } },
        platinum: { textId: 'Number of Ticket', vars: { ticket: 3 } }
    },
    {
        type: 'Asset Air Drop',
        silver: { textId: 'Entry for Gold / Silver NFTs', vars: { entry: 1 } },
        gold: { textId: 'Entries for Gold / Silver NFTs', vars: { entry: 2 } },
        platinum: {
            textId: 'Entries for Gold / Silver NFTs',
            vars: { entry: 3 }
        }
    }
];
